<template>
    <div class="modal" v-show="value">
        <div class="modal__content" v-bind:class="{ width90: (wid != undefined), width70: (wid == undefined) }">
            <div class="modal__header">
                <div class="modal__header-title text-light">
                    <span>{{ $t('common.preview') }}</span>
                </div>
            </div>
            <div class="modal__body">
                <preview-data v-if="item" ref="preview" :structure="structure" :items="item"></preview-data>
            </div>
            <div class="modal__footer">
                <div class="modal__footer__buttons">
                    <button class="btn" @click="close()">{{ $t('common.close') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import PreviewData from "./AnteprimaComponent";
    export default {
        name: 'anteprima-modal',
        components: {PreviewData},
        props: {
            value: {
                required: true
            },
            item: {
                required: true
            },
            structure: {
                required: true
            },
            wid: {
                required: false
            }
        },
        methods: {
            close() {
                this.$emit("input", !this.value);
            }
        }
    };
</script>
<style lang="scss">
   .width90 {
       width: 90vw !important;
   }
   .width70 {
       width: 70vw !important;
   }
</style>
